import { Navigate, Outlet } from 'react-router-dom';

import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';
import { useMatchCurrentPage } from '@/hooks/useMatchCurrentPage';
import { usePathSet } from '@/hooks/usePathSet';
import { useUIStyle } from '@/hooks/useUIStyle';

export const HomePageProtection = () => {
  const pathSet = usePathSet();
  const isDashboardPage = useMatchCurrentPage(['/landsteward/dashboard', '/buyer/dashboard']); // Harcode pages since paths is overwritten in usePathSet

  const hasConservationUIStyle = useUIStyle(OrganizationUIStyle.CONSERVATION);

  if (isDashboardPage && hasConservationUIStyle) {
    return <Navigate to={pathSet.plots} replace />;
  }

  return <Outlet />;
};
